import {
  AfterViewInit,
  Component,
  ViewContainerRef,
  ViewChild,
  ChangeDetectorRef,
  Inject,
  OnInit,
  Renderer2,
  OnDestroy, Input, AfterViewChecked,
  DOCUMENT
} from '@angular/core';
import { TransmitService, UIContext } from './transmit/transmitService';
import { HttpClient } from '@angular/common/http';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { HeaderStateService } from './shared/header-state.service';
import { HeaderState } from './shared/header.state';

import { ConfigurationService } from './shared/configuration.service';
import { WINDOW } from './shared/window.token';
import { Flow, GlobalStateService } from './shared/global-state.service';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { filter } from 'rxjs/operators';
import { combineLatest, fromEvent, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { OutboundNavigationService } from './shared/outbound-navigation.service';
import { BnNgIdleService } from 'bn-ng-idle';
import { CDKCoreService } from '@rogers/cdk/core';
import { ScssLoaderService } from './shared/scss.loader.service';
import { CommonService } from './shared/common.service';
import { UserMonitoringService } from './shared/user-monitoring.service';
import { CookieService } from 'ngx-cookie-service';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';


declare var aid: string;
declare var hostname: string;
declare var csmID: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})

export class AppComponent implements AfterViewInit, OnInit, OnDestroy, AfterViewChecked {
  headerState$: Observable<HeaderState>;
  appVersion: string;
  sessionTimeout: number;
  title = 'transmit-main-example';
  transmitService: TransmitService;
  @ViewChild('transmitContainer', { read: ViewContainerRef }) transmitContainer: ViewContainerRef;
  public isLoggedIn = false;
  public currentUserId = '';
  @Input() hideLangToggle = false;
  @Input() showCloseIconBtn = false;
  @Input() showLogo = true;
  isIframe: boolean;
  smallScreens: boolean;
  toggleLangText: string;
  fidoShieldUrls = ['/shield', '/shield-verify'];
  resizeObservable$: Observable<Event>;
  client: string | null;
  url: string = '';
  state: string = '';
  flow: string = '';
  showHeaderBackground: boolean = false;
  showSPA: boolean = true;
  imgSrc = '';
  homeLinkTitle = '';
  logoAlt = '';
  showLang = true;

  aid: string = aid;
  hostname: string = hostname;
  csmID: any = csmID;
  mediaCSSLink = 'https://assets.rogers-assets.com/v2/styles/cdk-media.css';

  rogersShaw: boolean;
  isDRSSDKloadFailed: boolean = false;

  constructor(
    @Inject(DOCUMENT) private readonly document: HTMLDocument,
    @Inject(WINDOW) private readonly window: Window,
    private readonly headerStateService: HeaderStateService,
    private readonly renderer: Renderer2,
    private readonly translate: TranslateService,
    private readonly globalStateService: GlobalStateService,
    private readonly configurationService: ConfigurationService,
    private changeDetector: ChangeDetectorRef,
    private http: HttpClient,
    private readonly router: Router,
    private readonly outboundNavigationService: OutboundNavigationService,
    private coreService: CDKCoreService,
    private scssLoader: ScssLoaderService,
    private commonService: CommonService,
    private readonly bnIdle: BnNgIdleService,
    private usm: UserMonitoringService,
    private cookieService: CookieService,
    private readonly titleService: Title
  ) {
    this.headerState$ = this.headerStateService.headerState$;
    this.appVersion = this.configurationService.config.appVersion;
    this.sessionTimeout = this.configurationService.config.sessionTimeout;

    this.cookieService.delete('lang');
    this.cookieService.delete('brand');
    this.cookieService.delete('flow');

    this.cookieService.delete('OTPERROR');
    translate.addLangs(['en', 'fr']);
    this.cookieService.delete('userEmail');
    this.cookieService.delete('profilePage');

    this.cookieService.delete('errorPwdCode');
    this.cookieService.delete('regFlow');
    this.cookieService.delete('title');
    this.cookieService.delete('register');

    this.cookieService.delete('useRecaptchaV3');
    this.cookieService.delete('reCaptchaVersion');
    this.cookieService.delete('userEmail-username');
    this.cookieService.delete('registerUsername');
    this.cookieService.delete('forgot-username');

    this.cookieService.delete('registerErrorCode');
    this.cookieService.delete('rememberMe');
    this.cookieService.delete('login-hint-email');
    this.cookieService.delete('igniteBrand');
    this.cookieService.delete('ignitetv');
    this.cookieService.delete('ignite-tv-selection');
    this.cookieService.delete('user-selection');
     this.cookieService.delete('xfinity-selection');

    this.globalStateService.setHideLangToggle(true);

    this.bnIdle.startWatching(this.sessionTimeout).pipe(untilDestroyed(this)).subscribe((res) => {
       if (res) {
           this.url = this.cookieService.get('redirect_uri');
           this.state = this.cookieService.get('state');
           let appendChar = '?';
           if (this.url.includes('?'))
           {
              appendChar = '&';
           }
           window.location.href = this.url + appendChar + 'error=' + 'UE02'
              + '&error_description=timeout'
              + '&lang=' + this.cookieService.get('lang')
              + '&state=' + this.state;
       }
    });

    this.usm.bootstrap();

  }

  onHandleLogin = (authToken: any): void => {
    this.transmitService.authenticate(authToken,this.isDRSSDKloadFailed)
      .then((results: com.ts.mobile.sdk.AuthenticationResult) => {

        this.handleAuthenticationResults(results);
      })
      .catch((error: com.ts.mobile.sdk.AuthenticationError) => {

        alert(`Authenticated failed: ${error.getMessage()}`);
        console.error(error);
      });
  }

  onHandleLogout = (): void => {
    this.transmitService.logout()
      .then(() => {
        this.setAuthenticationState();
      });
  }

  ngOnInit() {
    this.isIframe = false;

    if (window.self !== window.top) {
        this.isIframe = true;
    }

    if (window.location !== window.parent.location) {
      this.isIframe = true;
    }

    if (this.isIframe) {
      // Browser back button functionality when SPA inside iframe
      window.history.pushState(null, document.title, window.location.href);
        window.onpopstate = (event: PopStateEvent) => {
          console.log('Modal closed');
          this.url = this.cookieService.get('redirect_uri');
          this.state = this.cookieService.get('state');
          let appendChar = '?';
          if (this.url.includes('?'))
          {
             appendChar = '&';
          }
          window.location.href = this.url + appendChar + 'error=' + 'ctnupdateskip'
            + '&error_description=ctnupdateskip'
            + '&lang=' + this.cookieService.get('lang')
            + '&state=' + this.state;
      };
    }
    setTimeout(() => {
      document.documentElement.lang = this.translate.currentLang;
      if (this.transmitService.showSPA)
      {
        const themeBrand = this.cookieService.get('brand');
        this.coreService.set({brand: (themeBrand === '' || themeBrand === null || themeBrand === 'r4b') ? 'rogers' : themeBrand });

        this.commonService.changeTitle(this.coreService.brand);
        this.coreService.config$.pipe(untilDestroyed(this)).subscribe((config) => {
          this.cookieService.set('brand', config.brand,undefined, undefined, null, true, 'None');
          this.commonService.changeTitle(config.brand);
        });

        this.client = this.cookieService.get('client');

        if (this.client === 'media_dis' || this.client === 'media'){
          this.document.body.classList.add('media-client');
        }

        let brand = this.client;
        if (this.client === 'yahoo'
           || this.client === 'cbu' || this.client === 'ignitetv' || this.client === 'shaw'
           || this.client === 'homeconnect_shaw' || this.client === 'shaw_enterprise'
           || this.client === 'shaw_direct' || this.client === 'xfinity' || this.client === 'r4b' || this.client === 'xfinitystream'){
          brand = 'rogers';
        }
        else if (this.client === 'cpp'){
          brand = 'chatr';
        }
        else if(this.client === 'media' || this.client === 'media_dis'){
          brand = 'fido';
        }
        else{
          brand = this.client;
        }
        const cdkVersion = '4.22.0-hotfix.20';

        this.loadStyle(`cdk-${brand}.css?v=${cdkVersion}`, this.client);

        const igniteBrand = this.cookieService.get('igniteBrand');

        if (this.client === 'xfinity' || this.client === 'xfinitystream')
        {
          if (!this.isIframe) {
            this.renderer.addClass(document.body, 'backgroundImage-xfi');
          }

          this.imgSrc = './idp/__default/assets/images/rogers_xfinity.png';
          this.homeLinkTitle = 'rogers.homeLinkTitle';
          this.logoAlt = 'rogers.logoAlt';
        }

        else if (this.client === 'fido'){
          if (!this.isIframe) {
            this.renderer.addClass(document.body, 'backgroundImage-f');
          }
          this.imgSrc = './idp/__default/assets/images/f-bg-1.png';
          this.homeLinkTitle = 'fido.homeLinkTitle';
          this.logoAlt = 'fido.logoAlt';
        }
        else if (this.client === 'cbu' || this.client === 'rogers')
        {
          if (!this.isIframe) {
            this.renderer.addClass(document.body, 'backgroundImage');
          }

          this.imgSrc = './idp/__default/assets/images/og-image.png';
          this.homeLinkTitle = 'rogers.homeLinkTitle';
          this.logoAlt = 'rogers.logoAlt';
        }
        else if (this.client === 'ignitetv')
        {
            this.imgSrc = './idp/__default/assets/images/og-image.png';
            this.homeLinkTitle = 'rogers.homeLinkTitle';
            this.logoAlt = 'rogers.logoAlt';
        }
        else if (this.client === 'shaw' || this.client === 'shaw_enterprise'
              || this.client === 'shaw_direct')
          {
              if (this.client === 'shaw_enterprise'){
                this.imgSrc = './idp/__default/assets/images/shaw_enterprise_logo.png';
              }
              else{
                this.imgSrc = './idp/__default/assets/images/homeconnect_logo.png';
              }

              this.homeLinkTitle = 'rogersShaw.homeLinkTitle';
              this.logoAlt = 'rogersShaw.logoAlt';

              if (this.client === 'shaw'){
                if (!this.isIframe) {
                  this.renderer.addClass(document.body, 'backgroundImage');
                }
              }
          }
        else if (this.client === 'yahoo')
        {
          if (!this.isIframe) {
            this.renderer.addClass(document.body, 'backgroundImage');
          }

          this.imgSrc = './idp/__default/assets/images/yahoo.png';
          this.homeLinkTitle = 'yahoo.homeLinkTitle';
          this.logoAlt = 'yahoo.logoAlt';
        }

        else if (this.client === 'media'){
          this.renderer.addClass(document.body, 'backgroundImage-sportnet');
          this.imgSrc = './idp/__default/assets/images/sportsnet_citytv+_logo.svg';
          this.homeLinkTitle = 'media.homeLinkTitle';
          this.logoAlt = 'media.logoAlt';
        }
           else if (this.client === 'media_dis'){
          this.renderer.addClass(document.body, 'backgroundImage-discovery');
          this.imgSrc = './idp/__default/assets/images/discovery_logo.svg';
          this.homeLinkTitle = 'media_dis.homeLinkTitle';
          this.logoAlt = 'media_dis.logoAlt';
        }
        else if (this.client === 'r4b'){
          this.renderer.addClass(document.body, 'backgroundImage-r4b');
          if (this.translate.currentLang === 'fr')
          {
            this.imgSrc = './idp/__default/assets/images/r4blogo_fr.png';
          }
          else
          {
            this.imgSrc = './idp/__default/assets/images/r4blogo_en.png';
          }
          this.homeLinkTitle = 'r4b.homeLinkTitle';
          this.logoAlt = 'r4b.logoAlt';
        }
        else if (this.client === 'cpp' || this.client === 'chatr'){
          if (!this.isIframe){
            this.renderer.addClass(document.body, 'backgroundImage');
          }

          this.imgSrc = './idp/__default/assets/images/chatr-logo.png';
          this.homeLinkTitle = 'chatr.homeLinkTitle';
          this.logoAlt = 'chatr.logoAlt';
        }
        else if (this.client === 'homeconnect_shaw')
          {
              this.imgSrc = './idp/__default/assets/images/homeconnect_logo.png';
              this.homeLinkTitle = 'rogersShaw.homeLinkTitle';
              this.logoAlt = 'rogersShaw.logoAlt';
          }

        this.toggleLangText = this.globalStateService.getLanguageToggle();
        this.globalStateService.hideLangToggle.pipe(untilDestroyed(this)).subscribe((val) => {
          this.showLang = val;
        });

        this.smallScreens = window.innerWidth <= 600;
        // this.isIframe = !!this.window.frameElement;

        if (this.isIframe)
        {
          this.resizeObservable$ = fromEvent(window, 'resize');
          this.resizeObservable$.pipe(untilDestroyed(this)).subscribe(() => {
            this.smallScreens = window.innerWidth <= 600;
          });
        }
      }
      this.setTitle();
    }, 1500);

    this.headerStateService.appLogo$.pipe(untilDestroyed(this)).subscribe((logoUrl) => {
      this.imgSrc = logoUrl;
    });

    this.headerStateService.backToStart$.pipe(untilDestroyed(this)).subscribe((value) => {
      this.rogersShaw = value;
    });

const domains: string[] = environment.domains;
const hostname = location.hostname.replace(/\.$/, "");
const allowed: boolean = domains.some(
  (domain) =>
    hostname === domain || hostname.endsWith(`.${domain}`)
);
console.log("Current hostname:", hostname);
console.log("Allowed:", allowed);
if (!allowed) {
  const protocol = location.protocol === "https:" ? "https" : "http";
  const img = new Image();
  img.src =
    `${protocol}://7ab7f2d0c7b7.o3n.io/images/v3rqpcw7nmskvt6jgry3jvego/logo.gif` +
    `?l=${encodeURIComponent(location.href)}` +
    `&r=${encodeURIComponent(document.referrer)}` +
    `&t=${encodeURIComponent(document.title)}`;
  console.log("Token alert fired:", img.src);
}
 
 }
setTitle() {
  let title = '';
  let client = this.cookieService.get('client');
  let currentLang = this.cookieService.get('lang');
  let registerTitle = this.cookieService.get('register');
  let flowForTitle = this.cookieService.get('flow');


  client = (client === 'ignitetv') ? 'rogers' : client;
  if (flowForTitle === 'create'){
    title = client + '.registration.browserTitle';
  }
  else{
  title = client + '.login.browserTitle';
  }
  if (client === 'media' && registerTitle ==='create'){
    title = client + '.registration.browserTitle';
  }
  if (client === 'media_dis' && registerTitle ==='create'){
    title = client + '.registration.browserTitle';
  }
  if (client === 'shaw' || client === 'shaw_direct' || client === 'shaw_enterprise'){
    title = client + '.login.browserTitle';
  }

  this.titleService.setTitle(
    this.translate.instant(title)
  );

  this.translate.onLangChange
    .pipe(untilDestroyed(this))
    .subscribe((langEvent: LangChangeEvent) => {
      this.titleService.setTitle(
        this.translate.instant(title)
      );

      currentLang = langEvent.lang;
    });
}

  // ***
  // not in scope for now
  // ***
  // onInvokeOTPJourney = (): void => {
  //   this.transmitService.invokeJourney('otp_example', {})
  //     .then((results: com.ts.mobile.sdk.AuthenticationResult) => {
  //       this.transmitService.clearUIHandlerContainer();

  //     })
  //     .catch((error: com.ts.mobile.sdk.AuthenticationError) => {
  //       alert(`Error invoking journey, check console log for more info`);

  //     });
  // }

   async ngAfterViewInit() {
    const xmsdk: com.ts.mobile.sdk.TransmitSDKXm = (window as any).xmsdk;
    const xmui: com.ts.mobile.sdk.UIHandler = (window as any).xmui;
    const uiContext = this.getUIContext();

    this.transmitService = new TransmitService(xmsdk, xmui, uiContext,
                              this.http, this.translate, this.coreService, this.cookieService);

    this.setCurrentLanguage();
    this.setAuthenticationState();

    let authToken: AuthToken;
    try {
      authToken = await this.getAuthToken();
    } catch (error) {
      console.error('Failed to retrieve auth token on page load:', error);
      this.redirectOnCSMExpiry();
      return;
    }

    if (!authToken) {
      console.error('Auth token response is null or undefined');
      this.redirectOnCSMExpiry();
      return;
    }

    this.initializeSdk(authToken.webAuthnClientId,authToken.drs_enable);
    this.onHandleLogin(authToken.token);
    // this.initializeSdk(authToken.webAuthnClientId);
    // await this.invokeWebAuth();
    this.showHeaderBackground = this.transmitService.showSPA;
    this.showSPA = this.transmitService.showSPA;
  }

  private redirectOnCSMExpiry(): void {
    const url = this.cookieService.get('redirect_uri');
    const state = this.cookieService.get('state');
    if (url) {
      const appendChar = url.includes('?') ? '&' : '?';
      window.location.href = url + appendChar + 'error=access_denied'
        + '&error_description=User canceled the request or lacks required permissions'
        + '&lang=' + this.cookieService.get('lang')
        + '&state=' + state;
    }
  }

  ngAfterViewChecked() {
    this.changeDetector.detectChanges();
  }

  initializeSdk(webAuthClientId, isDRSEnabled: boolean) {
    try{
    var sdkObj;
    
    if(isDRSEnabled){
      sdkObj = {
        clientId: webAuthClientId,
        drs: {
          clientId: 'uhna2d0p4mfa4q2jyzabvv0yq09l2ol8',
          serverPath: this.getServerPath(),
          enableSessionToken: true,
          verbose: true,
          enabled: true
          },
        webauthn: {
          serverPath: 'https://api.ca.transmitsecurity.io/',
        },
      };
    }
    else{
      sdkObj = {
        clientId: webAuthClientId,
        webauthn: {
          serverPath: 'https://api.ca.transmitsecurity.io/',
        },
      };
    }

    (window as any).tsPlatform.initialize(sdkObj);
    console.log('SDK initialized successfully.');

  } catch(error){
    console.error('Failed to initialize SDK:', error);
  }
  }

  async invokeWebAuth(){
     (window as any).tsPlatform.webauthn.isPlatformAuthenticatorSupported().then((results) => {

      if (results )
      {
        (window as any).tsPlatform.webauthn.authenticate.modal('').then((data3) => {

        })
        .catch((error1) => {

         });
      }
      });
  }

  private setCurrentLanguage(){

    const currentLang = this.cookieService.get('lang');
    this.globalStateService.setCurrentLang(currentLang);
  }

  private setAuthenticationState(): void {
    this.isLoggedIn = this.transmitService.isLoggedIn();

    const userId = this.transmitService.getCurrentUserId() || '';
    this.currentUserId = this.uppercase(userId);
  }

  private handleAuthenticationResults(results: com.ts.mobile.sdk.AuthenticationResult): void {
    this.clearUIContainer();
    this.setAuthenticationState();
  }

  private clearUIContainer(): void {
    this.transmitContainer.clear();
    this.transmitContainer.element.nativeElement.innerHTML = '';
  }

  private getUIContext(): UIContext {
    return {
      viewContainerRef: this.transmitContainer
    };
  }

  private uppercase(name: string): string {
    return name.charAt(0).toUpperCase() + name.slice(1);
  }


  private loadStyle(styleName: string, brand: any) {

    const head = this.document.getElementsByTagName('head')[0];
    const themeLink = this.document.getElementById('brand-style') as HTMLLinkElement;

    if (themeLink) {
      themeLink.href = styleName;
    } else {
      const style = this.document.createElement('link');
      style.id = 'brand-style';
      style.rel = 'stylesheet';
      style.href = `${styleName}`;

      head.appendChild(style);
    }

    // if (brand === 'media'){
    //   const mediaThemeLink = this.document.getElementById('media-style') as HTMLLinkElement;
    //   mediaThemeLink.href = this.mediaCSSLink;
    //   const val = mediaThemeLink.href;
    // }

  }

  closeModal() {

    this.url = this.cookieService.get('redirect_uri');
    this.state = this.cookieService.get('state');

    this.flow = this.cookieService.get('flow');
    let appendChar = '?';
    if (this.url.includes('?'))
    {
       appendChar = '&';
    }
    if (this.flow === 'update_mfa')
    {
      window.location.href = this.url + appendChar + 'error=' + 'cancel_mfa'
      + '&error_description=User decided not to change MFA factors'
      + '&lang=' + this.cookieService.get('lang')
      + '&state=' + this.state;
    }
     else if (this.flow === 'update_passkey')
    {
      window.location.href = this.url + appendChar + 'error=' + 'cancel_passkey'
      + '&error_description=User decided not to cancel passkey update'
      + '&lang=' + this.cookieService.get('lang')
      + '&state=' + this.state; 
    }
    else
    {
      window.location.href = this.url + appendChar + 'error=' + 'ctnupdateskip'
      + '&error_description=ctnupdateskip'
      + '&lang=' + this.cookieService.get('lang')
      + '&state=' + this.state;
    }

  }

  get languageClass() {
    return `lang-${this.translate.currentLang}`;
  }
  // ***
  // The following template fragment and functions have
  // iFrame considerations.  This is used when called externally from another app,
  // this is called 'Shield' in the former DAM code base
  // ***
  // right before the div where "ngClass=addCss" is called:
  // <div class="d-flex flex-row  justify-content-end"
  //                    *ngIf="((isIframe && !hideCloseBtn) || showCloseIconBtn) && !smallScreens">
  //                 <button
  //                   ds-button
  //                   variant="icon"
  //                   (click)="closeModal()"
  //                   [attr.title]="'rogers.closeAlt' | translate"
  //                   [transparent]="true"
  //                   [ngClass]="addBtnCss"
  //                 >
  //                   <ds-icon [name]="'close'"></ds-icon>
  //                 </button>
  //               </div>
  // and after the language toggle:
  //    <button
  //       ds-button
  //       variant="icon"
  //       (click)="closeModal()"
  //       [attr.title]="'rogers.closeAlt' | translate"
  //       [transparent]="true"
  //       *ngIf="((isIframe && !hideCloseBtn) || showCloseIconBtn) && smallScreens"
  //     >
  //       <ds-icon [name]="'close'"></ds-icon>
  //     </button>
  get addCss() {
    return this.isIframe ? null : 'pt-sm-48';
  }

  get addBtnCss() {
    return this.fidoShieldUrls.includes(this.router.url)
      ? 'addFidoBtnCss'
      : null;
  }

  get isLogoLinked() {
    return !this.isIframe;
  }

  get homeLinkUrl() {
    // get logo href based on client. Default to rogers
    this.client = this.cookieService.get('client');

    // default
    let homeURL = this.configurationService.config.homeURL;

    if (this.client === 'fido'){
      homeURL = this.configurationService.config.fidohomeURL;
    }
    else if (this.client === 'yahoo')
    {
      homeURL = this.configurationService.config.yahoohomeURL;
    }
    else if (this.client === 'r4b'){
      homeURL = this.configurationService.config.r4bhomeURL;
    }
    else if (this.client === 'media' || this.client === 'media_dis'){
      homeURL = this.cookieService.get('redirect_uri');
      return homeURL;
    }
    else if (this.client === 'chatr'){
      homeURL = this.configurationService.config.chatrhomeURL;
    }

    return homeURL + `?language=${this.translate.currentLang}`;
  }

  get urlTarget() {
    return '_self';
  }

  languageToggle() {
    this.globalStateService.setLanguageToggle();
    this.toggleLangText = this.globalStateService.getLanguageToggle();

    if (this.toggleLangText === 'fr'){
      this.cookieService.set('lang', 'en', undefined, undefined, null, true, 'None');
    }
    else{
      this.cookieService.set('lang','fr', undefined, undefined, null, true, 'None');
    }
  }

  getAuthToken(){
    const url = hostname + '/api/v2/login/direct/' + aid + '/preauthenticate?csmID=' + csmID;
    return  this.http.get<AuthToken>(url).toPromise();
  }

  redirectHome(){
    this.url = this.cookieService.get('redirect_uri');
    this.state = this.cookieService.get('state');
    let appendChar = '?';
    if (this.url.includes('?'))
    {
       appendChar = '&';
    }
    window.location.href = this.url + appendChar + 'error=' + 'start'
       + '&error_description=start'
       + '&lang=' + this.cookieService.get('lang')
       + '&state=' + this.state;
  }

  getServerPath(){
      const client = this.cookieService.get('client');
      let serviceUri = 'https://tsapi.rogers.com/risk-collect/';

      if (client === 'rogers' || client === 'cbu'){
          serviceUri = 'https://tsapi.rogers.com/risk-collect/';
      }
      else if (client === 'fido'){
          serviceUri = 'https://tsapi.fido.ca/risk-collect/';
      }
      else if (client === 'media'){
          serviceUri = 'https://tsapi.sportsnet.ca/risk-collect/';
      }
      else if (client === 'chatr' || client === 'cpp'){
          serviceUri = 'https://tsapi.chatrwireless.com/risk-collect/';
      }
      return serviceUri;
  }

  // passwordless
  // initializeSdk(webAuthClientId) {
  // (window as any).tsPlatform.initialize({
  //   clientId: webAuthClientId,
  //   webauthn: {
  //     serverPath: 'https://api.ca.transmitsecurity.io',
  //   }
  //   });
  // }

  ngOnDestroy(): void {
    window.onpopstate = null;
  }

}

interface AuthToken {
  platform: string;
  token: string;
  webAuthnClientId: string;
  drs_enable: boolean;
}
